import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.disableFormInputs()
  }

  // FUNCTIONS FOR HABILITAR EDICION ---------------------------------------------

  disableFormInputs() {
    // Disable form inputs initially excluding elements with class 'notDisable'
    let inputs = document.querySelectorAll("form input:not([type=submit]):not([type=hidden]):not([type=button]):not(.notDisable)");
    inputs.forEach(input => {
      input.style.pointerEvents = "none";
    });

    // Remove the required from the selects
    let selects = document.querySelectorAll('select');
    selects.forEach(select => {
      // Check if the select contains the class notDisable, if so do not disable it, do not return just avoid
      if (!select.classList.contains('notDisable')) {
        select.style.pointerEvents = "none";
      }
    });

    // Disable map buttons initially
    let mapButtons = document.querySelectorAll('.map-button-edit');
    mapButtons.forEach(btn => {
      btn.style.pointerEvents = "none";
      btn.style.opacity = "0.5";
      btn.disabled = true;
    });
  }

  onEditBtnClick(event) {
    // Get the section where the edit btn was clicked
    let section = event.currentTarget.closest('.section');
    // Get the inputs within the section where the edit btn was clicked which are not submit buttons and dont have the class 'not_editable' also find checkboxes
    let inputs = section.querySelectorAll('input:not(.not_editable):not([type=submit]):not(.no-icon), select, input[type=checkbox]');
    inputs.forEach(input => {
      // Guarda el valor inicial como atributo de datos (normalizado)
      if (!input.dataset.originalValue) {
        if (input.type === 'checkbox') {
          input.dataset.originalValue = input.checked; // checkbox -> true/false
        } else {
          // Normalizar valores booleanos/undefined que vienen como strings
          const val = input.value;
          if (val === 'false' || val === 'null' || val === 'undefined') {
            input.dataset.originalValue = '';
          } else {
            input.dataset.originalValue = val || '';
          }
        }
      }
      input.style.pointerEvents = "auto";
      input.disabled = false;
      input.classList.add("edit-icon-input");
    });

    // Enable map buttons in this section
    let mapButtons = section.querySelectorAll('.map-button-edit');
    mapButtons.forEach(btn => {
      btn.style.pointerEvents = "auto";
      btn.style.opacity = "1";
      btn.disabled = false;
    });

    // Registrar listeners para validación de geo_code si es sección de domicilios
    // if (section.id === 'seccion_domicilios') {
    //   this.setupDomicilioValidation(section);
    // }

    // Get the ID of the current section
    let sectionId = section.id;

    // Show the cancelar and submit buttons in the section and hide all the other ones
    let submitCancelDiv = section.querySelectorAll('.submit_cancel_buttons');
    if (submitCancelDiv.length > 1) {
      // Remove the d-none class from the submit and cancel buttons
      submitCancelDiv.forEach(div => {
        div.classList.remove('d-none');
      });
    } else {
      let submitCancelDiv = section.querySelector('.submit_cancel_buttons');
      if (submitCancelDiv) {
        submitCancelDiv.classList.remove('d-none');
      }
    }

    // Add the d-none class to the other submit cancel buttons not in the section
    let otherSubmitCancelDiv = document.querySelectorAll(`.submit_cancel_buttons:not(#${sectionId} .submit_cancel_buttons)`);
    if (otherSubmitCancelDiv.length === 0) {
      // Add the d-none class to the submit and cancel buttons
      otherSubmitCancelDiv.forEach(div => {
        div.classList.add('d-none');
      });
    }

    // Change the pointer events to none for all the inputs which are not in the section
    let otherInputs = document.querySelectorAll(`input:not(#${sectionId} input):not([type=submit]):not(.no-icon), select:not(#${sectionId} select), input[type=checkbox]:not(#${sectionId} input[type=checkbox])`);
    otherInputs.forEach(input => {
      input.style.pointerEvents = "none";
      input.disabled = true;
      input.classList.remove("edit-icon-input");
    });

    // Check if the section has the class seccion_contactos
    if (section.classList.contains('seccion_contactos')) {
      // Find the divs with the class col and add the class col-12
      let divs = section.querySelectorAll('.col');
      divs.forEach(div => {
        div.classList.remove('col');
        div.classList.add('col-11');
      });
    } else {
      // Find the contactos section
      let contactosSection = document.querySelector('.seccion_contactos');
      // Find the divs with the class col-11 and add the class col
      if (contactosSection) {
        let divs = contactosSection.querySelectorAll('.col-11');
        divs.forEach(div => {
          div.classList.remove('col-11');
          div.classList.add('col');
        });
      };
    }

    // Remove the submit cancel buttons from the other sections
    let otherSections = document.querySelectorAll(`.section:not(#${sectionId})`);
    otherSections.forEach(section => {
      let submitCancelDiv = section.querySelectorAll('.submit_cancel_buttons');
      // Add the d-none class to the submit and cancel buttons
      submitCancelDiv.forEach(div => {
        div.classList.add('d-none');
      });

      // Check if the section has the class seccion_contactos
      if (section.classList.contains('seccion_contactos')) {
        // Find the divs with the class col-11 and add the class col
        let divs = section.querySelectorAll('.col-11');
        divs.forEach(div => {
          div.classList.remove('col-11');
          div.classList.add('col');
        });
      }
    });

    // Check the url if it contains /tablasbasicas/proveedores, Update the cabecera section title
    if (window.location.href.includes('/tablasbasicas/proveedores')) {
      let cabeceraSection = document.querySelector('.titulo-cabecera');
      if (cabeceraSection.textContent === "Ver proveedor") {
        cabeceraSection.textContent = "Editar proveedor";
      } else {
        cabeceraSection.textContent = "Ver proveedor";
      }
    }
  }

  setupDomicilioValidation(section) {
    // Campos importantes para validación de geo_code
    const importantFields = [
      'edit_paciente_domicilio_provincia',
      'edit_paciente_domicilio_ciudad',
      'edit_paciente_domicilio_calle',
      'edit_paciente_domicilio_numeracion'
    ];

    const geoCodeField = document.getElementById('paciente_geo_code');
    const guardarBtn = document.getElementById('paciente-guardar-btn');
    const mapBtn = document.getElementById('open-map-btn-paciente');

    // Guardar valores iniciales desde los data-attributes que ya cargó onEditBtnClick
    const initialValues = {};
    importantFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        initialValues[fieldId] = field.value;
      }
    });

    // Registrar listeners de 'change' en campos
    importantFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        // Solo registrar si no se ha registrado ya en esta sesión de edición
        if (!field.dataset.changeListenerRegistered) {
          field.addEventListener('change', (e) => {
            if (e.target.value !== initialValues[fieldId]) {
              // Campo cambió → limpiar geo_code y botón a azul
              if (geoCodeField) {
                geoCodeField.value = '';
              }
              if (mapBtn) {
                mapBtn.style.backgroundColor = '#0054AD';
                mapBtn.style.borderColor = '#0054AD';
              }
            }
          });
          field.dataset.changeListenerRegistered = 'true';
        }
      }
    });

    // Registrar listener en botón guardar
    if (guardarBtn) {
      // Solo registrar una vez para evitar duplicados
      if (!guardarBtn.dataset.validationListenerRegistered) {
        guardarBtn.addEventListener('click', (e) => {
          // Detectar cambios comparando valores actuales con iniciales
          let hayChanges = false;
          for (let fieldId of importantFields) {
            const field = document.getElementById(fieldId);
            if (field && field.value !== initialValues[fieldId]) {
              hayChanges = true;
              break;
            }
          }

          const geoCodeTieneValor = geoCodeField && geoCodeField.value && geoCodeField.value.trim() !== '';

          // Si hay cambios pero NO hay geo_code, abrir mapa
          if (hayChanges && !geoCodeTieneValor) {
            e.preventDefault();
            e.stopPropagation();
            if (window.openMapModalPaciente) {
              window.openMapModalPaciente();
            }
            return false;
          }
        });

        guardarBtn.dataset.validationListenerRegistered = 'true';
      }
    }
  }

  cancelarEdicion(event) {
    // Get the section where the cancel btn was clicked
    let section = event.currentTarget.closest('.section');

    if (section) {
      // Get the inputs within the section where the cancel btn was clicked which are not submit buttons and dont have the class 'not_editable'
      let inputs = section.querySelectorAll('input:not(.not_editable):not([type=submit]):not(.no-icon), select, input[type=checkbox]');
      inputs.forEach(input => {
        // Restaura el valor original desde el atributo de datos
        if (input.type === 'checkbox') {
          input.checked = input.dataset.originalValue === "true";
        } else {
          input.value = input.dataset.originalValue || "";
        }
        input.style.pointerEvents = "none";
        input.disabled = true;
        input.classList.remove("edit-icon-input");
      });

      // Disable map buttons in this section
      let mapButtons = section.querySelectorAll('.map-button-edit');
      mapButtons.forEach(btn => {
        btn.style.pointerEvents = "none";
        btn.style.opacity = "0.5";
        btn.disabled = true;
      });

      // Hide the cancelar and submit buttons
      let submitCancelDiv = section.querySelectorAll('.submit_cancel_buttons');
      // Add the d-none class to the submit and cancel buttons
      submitCancelDiv.forEach(div => {
        div.classList.add('d-none');
      });

      // Check if the section has the class seccion_contactos
      if (section.classList.contains('seccion_contactos')) {
        // Find the divs with the class col-11 and add the class col
        let divs = section.querySelectorAll('.col-11');
        divs.forEach(div => {
          div.classList.remove('col-11');
          div.classList.add('col');
        });
      }
    } else {
      // Get all the inputs in the document which are not submit buttons and dont have the class not editable
      let inputs = document.querySelectorAll('input:not(.not_editable):not([type=submit]):not(.no-icon), select, input[type=checkbox]');
      inputs.forEach(input => {
        input.style.pointerEvents = "none";
        input.disabled = true;
        input.classList.remove("edit-icon-input");
      });

      // Hide the cancelar and submit buttons
      let submitCancelDiv = document.querySelectorAll('.submit_cancel_buttons');
      // Add the d-none class to the submit and cancel buttons
      submitCancelDiv.forEach(div => {
        div.classList.add('d-none');
      });
    }
  }
}
